import React, { useEffect, useState } from 'react'
import "../../styles/main.scss"

import Footer from './Footer/Footer'
import Header from './Header/Header'

import { useStaticQuery, graphql } from 'gatsby'
import { useLocation } from '@reach/router'

const Layout = ({
    children
}) => {
    const {
        pathname
    } = useLocation()
    const [overflow, setOverflow] = useState(true)
    const {
        allContentfulPageProductCategory: {
            nodes
        }
    } = useStaticQuery(graphql`
        query {
            allContentfulPageProductCategory {
                nodes {
                    slug
                }
            }
        }
  `)
    useEffect(() => {
        if (nodes.find(({ slug }) => pathname.includes(slug))) {
            setOverflow(false)
        }
        return () => {
            setOverflow(true)
        }
    }, [pathname])

    useEffect(() => {
        const onMessage = (event) => {
            // Only handle messages from YouTube iframes
            if (
                typeof event.data === "string" &&
                event.data.indexOf("playerState") !== -1
            ) {
                const iframes = Array.from(document.querySelectorAll(
                "iframe[src*='youtube.com'], iframe[src*='youtube-nocookie.com']"
                ));
                const sourceIframe = iframes.find(iframe => iframe.contentWindow === event.source);
                // If a video started playing (playerState == 1)
                if (event.data.indexOf('"playerState":1') !== -1 && sourceIframe) {
                    iframes.forEach(iframe => {
                        if (iframe !== sourceIframe) {
                            iframe.contentWindow.postMessage(
                                JSON.stringify({ event: "command", func: "pauseVideo", args: [] }),
                                "*"
                            );
                        }
                    });
                }
            }
        };
        window.addEventListener("message", onMessage);
        return () => window.removeEventListener("message", onMessage);
    }, []);

    // useEffect(() => {
    //     window.zESettings = {
    //         webWidget: {
    //             chat: { suppress: true },
    //             helpCenter: { suppress: true },
    //             talk: { suppress: true },
    //             answerBot: { suppress: true },
    //         }
    //     };

    //     window.zESettings = {
    //         webWidget: {
    //             chat: {
    //                 departments: { select: 'france' }
    //             }
    //         }
    //     };
    // }, [])

    return (
        <div>
            <Header />
            <main className={`main ${overflow ? 'overflow' : ''}`}>
                <div className='page'>{children}</div>
            </main>
            <Footer />
        </div>
    )
}

export default Layout